const DownloadIcon = () => {
  return (
    <svg viewBox="0 0 18 18">
      <path
        d="M56.367,65.367a9,9,0,1,1,9-9A9,9,0,0,1,56.367,65.367Zm3.53-8.03a.75.75,0,0,0-1.061,0l-1.72,1.72V51.867a.75.75,0,0,0-1.5,0v7.189l-1.72-1.72A.75.75,0,0,0,52.837,58.4l3,3a.75.75,0,0,0,1.06,0l3-3A.75.75,0,0,0,59.9,57.337Z"
        transform="translate(-47.367 -47.367)"
      />
    </svg>
  );
};

export default DownloadIcon;
